import { render, staticRenderFns } from "./lock_issue_sidebar.vue?vue&type=template&id=602eb73e"
import script from "./lock_issue_sidebar.vue?vue&type=script&lang=js"
export * from "./lock_issue_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports